import styled from "styled-components";

export const OptionsConsultaGeneral = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  padding: 10px;
`;

export const ContentSearch = styled.div`
  padding: 10px;
`;

export const OptionsConsultaXpago = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
`;
